<template>
  <b-card no-body class="p-2">
    <!-- Header -->
    <div class="d-flex flex-wrap justify-content-between align-items-center mb-2 gap-2">
      <b-card-title class="mb-0">
        <span class="fs-4">Trend Operator per Platform</span>
      </b-card-title>
    </div>

    <!-- Custom Tabs -->
    <div class="d-flex flex-wrap gap-2 mb-2">
      <div 
        v-for="plat in platforms" 
        :key="plat.id"
        class="custom-tab-card cursor-pointer d-flex align-items-center justify-content-center mr-1"
        :class="{'active-tab': activeTab === plat.id}"
        @click="activeTab = plat.id"
      >
        <feather-icon :icon="plat.icon" size="18" class="mr-50" />
        <span class="font-weight-bolder">{{ plat.label }}</span>
      </div>
    </div>
    
    <!-- Chart -->
    <loader v-if="loading" />
    <div v-else-if="currentSeries.length > 0">
      <lineChart :data="chartData" />
    </div>
    <div v-else class="text-center py-5">
      <p class="text-muted">Tidak ada data untuk platform ini.</p>
    </div>
  </b-card>
</template>

<script>
import loader from "@/views/components/loader.vue";
import lineChart from "@/views/components/lineChart.vue";
import { BCard, BCardTitle } from "bootstrap-vue";

export default {
  name: "SmdOperatorTrendChart",
  components: {
    loader,
    lineChart,
    BCard,
    BCardTitle
  },
  props: {
    loading: { type: Boolean, default: false },
    data: { type: Object, default: () => ({ categories: [], series: {} }) }
  },
  data() {
    return {
      activeTab: "facebook",
      platforms: [
        { id: "facebook", label: "Facebook", icon: "FacebookIcon" },
        { id: "instagram", label: "Instagram", icon: "InstagramIcon" },
        { id: "tiktok", label: "Tiktok", icon: "VideoIcon" }
      ]
    };
  },
  computed: {
    currentSeries() {
      if (!this.data || !this.data.series) return [];
      return this.data.series[this.activeTab] || [];
    },
    chartData() {
      // Menyamakan konfigurasi dengan SmdTrendChart.vue
      return {
        type: "area",
        categories: this.data.categories || [],
        series: this.currentSeries,
        colors: ["#7367f0", "#ff9f43", "#ea5455", "#28c76f", "#00cfe8", "#826bf8", "#2b9bf4"],
        strokeWidth: [3, 3, 3, 3, 3, 3, 3],
        fill: {
          type: "gradient",
          gradient: {
            shadeIntensity: 1,
            opacityFrom: 0.4,
            opacityTo: 0.05,
            stops: [0, 90, 100]
          }
        },
        yaxisTitle: {
          text: "Jumlah Data",
          offsetX: 6,
          style: {
            color: "#A9A9A9",
            fontSize: "12px",
            fontFamily: "Montserrat",
            fontWeight: 600,
          }
        },
        markers: { 
          size: 0,
          hover: { size: 6 }
        },
        tooltip: { theme: "dark" },
        legend: { show: true },
      };
    }
  }
};
</script>

<style scoped>
.custom-tab-card {
  padding: 8px 16px;
  border: 1px dashed #4b4b4b;
  border-radius: 20px;
  transition: all 0.2s ease-in-out;
}
.custom-tab-card.active-tab {
  border: 1px solid #7367f0;
  box-shadow: 0 4px 12px rgba(115, 103, 240, 0.4);
  background-color: rgba(115, 103, 240, 0.12);
  color: #7367f0;
}
.custom-tab-card:not(.active-tab):hover {
  background-color: rgba(255, 255, 255, 0.05);
}
</style>
